// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#eb5757","bgColor":"white","redline":"b_b","redline_animate":"b_c","dash":"b_d","fade":"b_f"};